export const formatThousandsWithSpaces = (value: number): string => {
  const stringValue = value.toString()

  if (value >= 1000) {
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  return stringValue
}
